
(function() {

    var multiactionCheckbox = function($timeout, $templateCache) {
        return {
            restrict: "E",
            scope: {
                /*  '@' Text binding  '=' Two-way binding  '&' Method binding  '<' One-way binding  */
                id: "@uniqueId",
                tickall: "=",
                multiactionData: "=",
                destroyData:"&"
            },
            replace:true,
            template: $templateCache.get('components/listing/multiactionCheckbox.html'),
            link: function (scope, element, attrs) {

                var cancelQueryObserver;

                // On load init there must be timeout as on listings on whole page load it's loaded from backend
                // rather than ng-include (listing directive, hence once it gets destroyed it clears the value.
                // With timeout the value first gets cleared and then reinitialized in here
                $timeout(function(){
                    initData();

                    if(attrs.solr=="true"){
                        // we need to observe data-query attribute as it changes after the solr tiles are replaced with full content tiles
                        cancelQueryObserver = attrs.$observe('query', function(newVal){
                            scope.multiactionData[scope.id].query = newVal;
                            cancelQueryObserver(); // I think it can be run only once and then we can remove the observer
                        });
                    }
                });


                var initData = function(){
                    if( !angular.isDefined(scope.tickall) ){
                        scope.tickall = {};
                    }
                    if( !angular.isDefined(scope.multiactionData) ) {
                        scope.multiactionData = {};
                    }
                    if( !angular.isDefined(scope.tickall[scope.id]) ){
                        scope.tickall[scope.id] = false;
                    }
                    if( !angular.isDefined(scope.multiactionData[scope.id]) ) {
                        scope.multiactionData[scope.id] = {
                            'query': attrs.query,
                            'name' : attrs.multiName
                        }
                    }
                };


                // scope.$on('multiaction-checkbox-destroyed', initData);

                var destroyData = angular.isDefined(scope.destroyData()) ? scope.destroyData() : true; // true by default

                // destroy what's ticked while element is removed from the screen - ie. next page with pagination
                element.on('$destroy', function() {
                    var debugDestroy = false;
                    if(scope.tickall !== undefined) {
                        var isChecked = scope.tickall[scope.id];
                        // Delete the data if told to or if currently not selected
                        if(destroyData || !isChecked) {
                            delete scope.tickall[scope.id]; // TODO: remove tickall from xlTickBox.gsp and try delete checked (?)
                            if(debugDestroy)
                                console.log('DELETED scope.tickall[',scope.id,']', isChecked);
                        } else if(debugDestroy){
                            console.log('PRESERVED scope.tickall[',scope.id,']', isChecked);
                        }

                        // Delete the data if told to or if currently not selected
                        if(scope.multiactionData !== undefined && (destroyData || !isChecked)) {
                            delete scope.multiactionData[scope.id];
                            if(debugDestroy)
                                console.log('DELETED scope.multiactionData[',scope.id,']', isChecked);
                        } else if(debugDestroy){
                            console.log('PRESERVED scope.multiactionData[',scope.id,']', isChecked);
                        }
                    }

                    if(attrs.solr="true" && angular.isDefined(cancelQueryObserver)){
                        cancelQueryObserver();
                    }
                });
            }
        }
    };
    multiactionCheckbox.$inject = ['$timeout', '$templateCache'];
    angular.module('app').directive('multiactionCheckbox', multiactionCheckbox);

}());